"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionInfoCard = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Utils_1 = require("../Utils");
var SessionInfoLine_1 = require("../Components/SessionInfoLine");
var luxon_1 = require("luxon");
var LocationFlag_1 = require("../Components/LocationFlag");
var styles = __importStar(require("./SessionView.css"));
var SessionInfoCard = function (_a) {
    var basicSession = _a.basicSession, timeZone = _a.timeZone;
    var timeSince = luxon_1.DateTime.fromJSDate(basicSession.timestamp).toRelative({ round: true });
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: styles.firstRowCard },
        react_1.default.createElement(kaleidoscope_1.Stack, { padding: "l", align: "start", gap: { default: "m", tablet: "l" } },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "4", strong: true }, "Session details"),
            react_1.default.createElement(SessionInfoLine_1.SessionInfoList, null,
                react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "Time", IconType: icons_1.Calendar, info: "".concat(timeSince, " \u2014 ").concat((0, Utils_1.formatDatetime)(basicSession.timestamp, timeZone, true)) }),
                react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "Duration", IconType: icons_1.Clock, info: (0, Utils_1.formatCompactViewDuration)(basicSession.duration) }),
                react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "Location", iconElement: react_1.default.createElement(LocationFlag_1.LocationFlag, { countryCode: basicSession.countryCode }), info: basicSession.location }),
                react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "Device", IconType: icons_1.FrameDevice, info: basicSession.device }),
                react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "Browser", IconType: icons_1.Sidebar, info: basicSession.browser }),
                react_1.default.createElement(SessionInfoLine_1.SessionInfoLine, { title: "IP address", IconType: icons_1.Domain, info: basicSession.ip })))));
};
exports.SessionInfoCard = SessionInfoCard;
